
import React from "react";

interface FormErrorProps {
  error: string | null;
}

const FormError: React.FC<FormErrorProps> = ({ error }) => {
  if (!error) return null;
  
  return (
    <div className="bg-destructive/10 border border-destructive text-destructive px-4 py-2 rounded-md">
      <p className="font-medium">Error</p>
      <p className="text-sm">{error}</p>
    </div>
  );
};

export default FormError;
